/**
 * Event bridge between the demo request adapter (plain module code) and the
 * React toast system — the same idea as `utils/apiErrors.ts`, kept separate so
 * a demo no-op never renders as a red API error.
 */

type NoticeListener = (message: string) => void;

const listeners = new Set<NoticeListener>();

export const DEMO_SAVE_NOTICE = 'Demo mode — changes are not saved';

export function onDemoNotice(listener: NoticeListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function emitDemoNotice(message: string = DEMO_SAVE_NOTICE): void {
  listeners.forEach(listener => listener(message));
}
